/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
    errorId: {
        invalidMajor: string,
        invalidMinor: string,
    },
    myMajor: string,
    myMinor: string,
    areaOfStudy: string,
    majorPlaceholder: string,
    minorPlaceholder: string,
    optionalExplanation: string,
    major: {
        tooltipText: string,
    },
    ClassGroupOptions: {
        arts: string,
        business: string,
        education: string,
        healthProfessions: string,
        humanities: string,
        protectiveServices: string,
        scienceTechnologyMath: string,
        tradesServices: string,
    },
    ClassNameOptions: {
        art1: string,
        art2: string,
        art3: string,
        art4: string,
        art5: string,
        art6: string,
        art7: string,
        art8: string,
        art9: string,
        art10: string,
        art11: string,
        art12: string,
        art13: string,
        art14: string,
        art15: string,
        biz1: string,
        biz2: string,
        biz3: string,
        biz4: string,
        biz5: string,
        biz6: string,
        biz7: string,
        biz8: string,
        edu1: string,
        edu2: string,
        edu3: string,
        edu4: string,
        edu5: string,
        edu6: string,
        edu7: string,
        edu8: string,
        hlth1: string,
        hlth2: string,
        hlth3: string,
        hlth4: string,
        hlth5: string,
        hlth6: string,
        hlth7: string,
        hlth8: string,
        hlth9: string,
        humn1: string,
        humn2: string,
        humn3: string,
        humn4: string,
        humn5: string,
        humn6: string,
        humn7: string,
        humn8: string,
        humn9: string,
        humn10: string,
        humn11: string,
        humn12: string,
        humn13: string,
        humn14: string,
        humn15: string,
        humn16: string,
        humn17: string,
        protc1: string,
        protc2: string,
        protc3: string,
        protc4: string,
        protc5: string,
        protc6: string,
        protc7: string,
        scnc1: string,
        scnc2: string,
        scnc3: string,
        scnc4: string,
        scnc5: string,
        scnc6: string,
        scnc7: string,
        scnc8: string,
        scnc9: string,
        scnc10: string,
        scnc11: string,
        scnc12: string,
        scnc13: string,
        trad1: string,
        trad2: string,
        trad3: string,
        trad4: string,
        trad5: string,
        trad6: string,
    },
};

export const studentMessagesEN: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    address: 'Address',
    addressPlaceholder: 'Address',
    birthDate: 'Date of Birth',
    branchOfService: 'Branch of service',
    branchOfServicePlaceholder: 'Branch Of Service',
    changeLanguage: 'Change language',
    city: 'City',
    cityPlaceholder: 'City',
    company: 'Company',
    companyPlaceholder: 'Company',
    country: 'Country',
    countryPlaceholder: 'Country',
    myMajor: 'My Major',
    myMinor: 'My Minor',
    optionalExplanation: '(optional)',
    areaOfStudy: 'Area of Study',
    majorPlaceholder: 'Major',
    minorPlaceholder: 'Minor',
    major: {
        tooltipText: 'Some of our partners offer additional discounts for students who provide information about their area of study. To qualify for these discounts you may provide your answers below.',
    },
    classGroupOptions: {
        arts: 'Arts',
        business: 'Business',
        education: 'Education',
        healthProfessions: 'Health Professions',
        humanities: 'Humanities',
        protectiveServices: 'Protective Services',
        scienceTechnologyMath: 'Science, Technology, & Math',
        tradesServices: 'Trades & Services',
    },
    classNameOptions: {
        art1: 'Art, General',
        art2: 'Art History, Criticism & Conservation',
        art3: 'Dance',
        art4: 'Design, Illustration, & Visual Communications',
        art5: 'Fashion/Apparel Design',
        art6: 'Fine/Studio Arts',
        art7: 'Film, Video, & Television Production',
        art8: 'Industrial Design',
        art9: 'Interior Design',
        art10: 'Music, General',
        art11: 'Music, Performance',
        art12: 'Music, Theory & Composition',
        art13: 'Photography/Cinematography',
        art14: 'Theatre Arts/Drama',
        art15: 'Web, Technology, & Digital Information Design',
        biz1: 'Accounting',
        biz2: 'Advertising, Sales, & Marketing',
        biz3: 'Agricultural Business',
        biz4: 'Business Management, General',
        biz5: 'Finance',
        biz6: 'Hotel & Resturant Management',
        biz7: 'Real Estate',
        biz8: 'Tourism & Travel',
        edu1: 'Counseling & Student Services',
        edu2: 'Early Childhood Education',
        edu3: 'Education, General',
        edu4: 'English-as-a-Second-Language Education',
        edu5: 'Foreign Languages Education',
        edu6: 'K–12 Education',
        edu7: 'Special Education',
        edu8: 'Teacher Education, Subject-Specific',
        hlth1: 'Dental Studies',
        hlth2: 'Food And Nutrition',
        hlth3: 'Health Care Management',
        hlth4: 'Health Professions, General',
        hlth5: 'Kinesiology And Physical Therapy',
        hlth6: 'Medical Assistants And Technicians',
        hlth7: 'Nursing',
        hlth8: 'Pharmacy',
        hlth9: 'Public Health',
        humn1: 'Anthropology and Sociology',
        humn2: 'Communications, General',
        humn3: 'Communications, Journalism/Photojournalism',
        humn4: 'Communications, Media',
        humn5: 'Economics',
        humn6: 'English',
        humn7: 'Foreign Languages',
        humn8: 'Global Studies',
        humn9: 'History',
        humn10: 'Interdisciplinary Studies',
        humn11: 'International Relations',
        humn12: 'Legal Studies',
        humn13: 'Philosophy',
        humn14: 'Political Science',
        humn15: 'Psychology',
        humn16: 'Public Policy and Social Services',
        humn17: 'Religious Studies',
        protc1: 'Criminal Justice & Criminology',
        protc2: 'Cyber/Computer Forensics and Counterterrorism',
        protc3: 'Forensic Science and Technology',
        protc4: 'Fire Protection and Prevention',
        protc5: 'Homeland Security and Disaster Management',
        protc6: 'Legal & Pre-Law Studies',
        protc7: 'Security Services',
        scnc1: 'Agricultural Sciences',
        scnc2: 'Architecture',
        scnc3: 'Astronomy',
        scnc4: 'Biology',
        scnc5: 'Chemistry',
        scnc6: 'Computer Science',
        scnc7: 'Engineering',
        scnc8: 'Environmental Science',
        scnc9: 'Geological & Earth Sciences',
        scnc10: 'Information Technology',
        scnc11: 'Math',
        scnc12: 'Physics',
        scnc13: 'Veterinary Studies',
        trad1: 'Building and Construction',
        trad2: 'Cosmetology',
        trad3: 'Culinary Arts',
        trad4: 'Engineering Technicians',
        trad5: 'Mechanics & Repair',
        trad6: 'Trades and Personal Services',
    },
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada (exclues Québec)',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast (Cote D\'Ivoire)',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (French)',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia & South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique (French)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia (French)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (French)',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (French)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovak Republic',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'Saint Tome (Sao Tome) and Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican City State',
        VC: 'Saint Vincent & Grenadines',
        VE: 'Venezuela',
        VG: 'Virgin Islands (British)',
        VI: 'Virgin Islands (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna Islands',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    dateTime: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        month: 'Month',
        day: 'Day',
        year: 'Year',
        '2_MIN': '2 minutes',
        '20_MIN': '20 minutes',
        '2_HOURS': '2 hours',
        '24_HOURS': '24 hours',
        '3_DAY': '3 days',
        A_FEW_MINUTES: 'a few minutes',
        A_FEW_HOURS: 'a few hours',
        A_FEW_DAYS: 'a few days',
    },
    locales: {
        ar: 'Arabic',
        bg: 'Bulgarian',
        cz: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        'en-GB': 'English (UK)',
        'en-US': 'English',
        'es-ES': 'Spanish (Spain)',
        es: 'Spanish',
        fi: 'Finnish',
        'fr-CA': 'French (Canadian)',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        id: 'Indonesian',
        is: 'Icelandic',
        it: 'Italian',
        iw: 'Hebrew',
        ja: 'Japanese',
        ko: 'Korean',
        lt: 'Lithuanian',
        ms: 'Malay',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russia',
        sk: 'Slovak',
        sl: 'Slovenian',
        sr: 'Serbian',
        sv: 'Swedish',
        tr: 'Turkish',
        'zh-HK': 'Chinese (Hong Kong)',
        zh: 'Chinese (Traditional)',
    },
    mdischargeDate: 'Discharge date',
    emailAddress: 'Email address',
    emailAddressPlaceholder: 'Email address',
    phoneNumber: 'Mobile Number',
    phoneUsPlaceholder: '555-555-5555',
    error: 'Error',
    limitExceededError: 'Verification Limit Exceeded',
    firstName: 'First name',
    firstNamePlaceholder: 'First name',
    memberId: 'ID Number',
    memberIdPlaceholder: 'ID Number',
    optional: 'Optional',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    lastName: 'Last name',
    lastNamePlaceholder: 'Last name',
    loading: 'Loading...',
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    postalCodePlaceholder: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    schoolName: 'University / College name',
    schoolNamePlaceholder: 'University / College name',
    sheeridFaqs: 'SheerID FAQs',
    smsCodePlaceholder: 'SMS Code',
    state: 'State',
    statePlaceholder: 'State',
    status: 'Status',
    statusPlaceholder: 'Status',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: '(Used for verification purposes only)',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMembershipStatus: 'Verify My Membership Status',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'Verify My Medical Professional Status',
    verifyMyEmploymentStatus: 'Verify My Employee Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organization',
    organizationPlaceholder: 'Organization',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    tryAgain: 'Try again',
    errorId: {
        invalidMajor: 'Invalid major',
        invalidMinor: 'Invalid minor',
        apiRateLimitExceeded: 'Unable to process your request at this time, please try again later',
        dischargeDateBeforeBirthDate: 'Discharge Date before birthdate',
        docReviewLimitExceeded: 'Document review limit exceeded',
        expiredEmailLoopToken: 'We are sorry, the page you requested cannot be found. The URL may be incorrect or the page you\'re looking for is no longer available.',
        expiredProgram: 'This link is no longer active',
        expiredSMSCode: 'Verification code expired',
        failedToFetch: 'Failed HTTP request',
        futureBirthDate: 'Future birthdate',
        futureDischargeDate: 'Future discharge date',
        internalServerError: 'Internal server error',
        invalidAddress: 'Invalid address',
        invalidApiToken: 'Provided API token was invalid or empty',
        invalidBirthDate: 'Invalid birth date',
        invalidCity: 'Invalid city',
        invalidCountry: 'Invalid country',
        invalidDischargeDate: 'Invalid discharge date',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        invalidEmail: 'Invalid email',
        invalidEmailLoopToken: 'We are sorry, the page you requested cannot be found. The URL may be incorrect or the page you\'re looking for is no longer available.',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidFirstName: 'Invalid first name',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidLastName: 'Invalid last name',
        invalidMemberId: 'Invalid ID Number',
        invalidMilitaryStatus: 'Invalid military status',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidOrganization: 'You must select an organization from the list',
        invalidPhoneNumber: 'Invalid mobile number',
        invalidPostalCode: 'Invalid postal code',
        invalidProgram: 'Invalid program',
        invalidRequest: 'Invalid request',
        invalidSMSCode: 'Verification code could not be validated',
        invalidSocialSecurityNumber: 'Invalid SSN',
        invalidState: 'Invalid state',
        invalidStatus: 'Invalid status',
        invalidStep: 'Invalid step',
        marketConsentRequired: 'Market consent required',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxSMSCodeLimitExceeded: '',
        noProgram: 'No program found',
        noRemainingRewardCodes: "Sorry, this offer is currently closed and we can't verify you at this time. Please try again later.",
        notApproved: 'Not approved',
        notFound: 'Not found',
        noValidFiles: 'No valid files',
        noVerification: 'No verification found',
        outsideAgePerson: 'Birthdate is not eligible for this offer.',
        requestTimeout: 'Request timeout',
        simulatedError: 'This is a simulated error',
        unauthorizedDomain: 'Unauthorized domain',
        underagePerson: 'Persons under age 16 are not eligible for this offer.',
        unknownError: 'Unknown Error',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
    },
    step: {
        personalInfo: {
            title: 'Register Now for Our Student Discount Program',
            subtitle: "Verify you're a student at a degree-granting College or University.",
            howDoesVerifyingWorkDetails: `
                To be eligible for this offer, you must currently be enrolled in a degree-granting,
                accredited school of higher education.
                <br><br>
                {companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only
                collects information that assists in verifying your eligibility.
                Additional information or documentation may be requested.`,
            tryAgain: {
                title: 'Check Your Name & Birthdate',
                subtitle: 'Your full name and birthdate must match what is on your official school records.',
            },
        },
        docUpload: {
            title: 'We need your ID & class schedule',
            subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
            acceptableUploadExamples: 'Acceptable examples include:',
            acceptedTypes: 'File must be .jpg .jpeg .png .pdf .gif or .bmp',
            addFile: 'Add files',
            cancelButtonLabel: 'Cancel',
            fileInstructions: 'Drag &amp; drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            submitButtonLabel: 'Submit',
            rejectedSubtitle: 'We were unable to confirm your eligibility due to:',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying students.
                <br/><br/>
                Documents are used only for verifying your student status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}`,
            uploadInstructions: 'Upload your school-issued document that shows:',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that\'s bright and crisp, and try submitting again.',
                DOCUMENT_PASSWORD_PROTECTED: 'We are unable to accept password protected documents.',
                DOCUMENT_LIKELY_FRAUD: 'The document you submitted is insufficient for establishing eligibility for this offer.',
                DOCUMENT_UNSUPPORTED: 'The document you submitted is not on the list of accepted document types.',
                DOCUMENT_HANDWRITTEN: 'We cannot accept handwritten documents.',
                MISSING_INFORMATION: 'The document you submitted does not provide all of the information necessary to determine eligibility for this offer.',
                MISSING_INFORMATION_PERSON_NAME: 'The document you submitted is missing a first and/or last name.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'The document you submitted does not include an organization name that confirms your connection to that organization.',
                DOCUMENT_EXPIRED: 'The document you submitted has expired.',
                DOCUMENT_OUTDATED: 'The document you submitted is missing an issue date or was issued too far in the past.',
                MISMATCH_PERSON_NAME: 'The information on the document you submitted does not match the first and/or last name submitted on the verification form.',
                MISMATCH_ORGANIZATION: 'The organization name on the document(s) you submitted does not match the organization you listed on the verification form.',
                MISMATCH_STATUS: 'The status on the document you submitted does not match the status you listed on your verification form.',
                INELIGIBLE_ORGANIZATION: 'The organization on the document you submitted is not eligible for this offer.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'The document you submitted does not prove enrollment in the current term.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'High School Students are not eligible for this offer.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'The company name or address in your document does not match what you entered on the verification form.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Please upload a paystub that was issued within the last 30 days.',
                MISSING_INFORMATION_BIRTHDATE: 'The document you submitted is missing a birthdate, or your age is ineligible for this offer.',
                MISMATCH_BIRTHDATE: 'The birthdate on the document you submitted does not match the birthdate you listed on the verification form.',
                DOCUMENT_OUTDATED_FACULTY: 'The document you submitted does not prove employment in the current academic year.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'The job title on the document you submitted is missing or does not match what you entered on the verification form.',
                OTHER_CONTACT_US: 'We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'A field in the document provided did not match with what was provided on the verification form.',
            },
            uploadInfo: {
                fullName: 'Your full name',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                age: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Your medical professional status',
                    validDate: 'A currently valid date',
                },
                employment: {
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                member: {
                    idCard: 'Membership Document',
                    payStub: 'Pay stub from within last 90 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                age: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificate of license',
                    idCard: 'Nursing ID card with expiration date',
                    photoPayStub: 'Photo ID and recent Pay Stub',
                },
                employment: {
                    employeeIdCard: 'Employee ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    officialLetter: 'An official letter',
                },
                firstResponder: {
                    idCard: 'ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    letter: 'An official letter',
                },
            },
        },
        pending: {
            titleCountdown: 'Processing',
            titleReview: 'Processing',
            title: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status. <br> This process may take up to {maxReviewTime}.',
            subtitle2: 'Wait here or let us notify you of the outcome.',
            subtitle3: 'You will be contacted via email.',
            subtitleCountdown: 'Hang tight while we upload and scan your documents.',
        },
        success: {
            title: 'Success',
            subtitle: 'You have been Verified. <br><br> Your account has been updated to reflect your student status.',
            copyCouponCode: 'Copy Coupon code',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to {companyName} customer service.
            `,
        },
        sso: {
            title: 'Verify using your school credentials',
            subtitle: "Please sign in to your school's web portal. It will open in a new tab.",
            login: 'Sign in to my school',
        },
        collectSocialSecurityNumber: {
            title: 'Enter your social security number',
            useSsn: 'Verify using your social security number',
            uploadDoc: 'Upload a document',
            selectOption: 'Select an option',
            uploadInstead: 'Upload a document instead',
        },
        smsLoop: {
            titleWithNumber: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
            titleWithoutNumber: "We've sent an SMS to your mobile number. Please enter the code here.",
            verificationCode: 'Verification Code',
            errors: {
                codeVerification: 'Verification code could not be validated.',
                codeExpired: 'Verification code could not be validated.',
                codeResendLimit: 'Maximum number of re-tries has been reached.',
                resend: 'Error sending the SMS message',
            },
            successResend: 'SMS message re-sent successfully',
            incorrectNumber: {
                incorrectNumber1: 'Incorrect number? Click ',
                incorrectNumber2: 'here ',
                incorrectNumber3: 'to return to {companyName}',
            },
            resendButton: 'Re-send',
            submitButton: 'Submit',
        },
        emailLoop: {
            title: 'Check your email',
            subtitleWithEmail: 'An email has been sent to {email} with a personalized link to complete the verification process.',
            subtitleWithoutEmail: 'An email has been sent to your email account with a personalized link to complete the verification process.',
            subtitle2: 'Please check for an email from us (verify@sheerid.com) for all the details.',
        },
    },
    ssn: 'Social Security Number',
    ssnPlaceholder: '000-00-0000',
    // The preferred default:
    infoShared: 'Information entered here will be used for verification purposes and shared with {companyName}. ',
    // region: Keep these for backward compatibility
};
